<template>
  <div>
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>查詢</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form>
            <v-row align="center">
              <v-col cols="12" md="3">
                <DateRange
                  label="生效日期(起)"
                  v-model="searchForm.startStartOn"
                />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange
                  label="生效日期(迄)"
                  v-model="searchForm.endStartOn"
                />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange
                  label="失效日期(起)"
                  v-model="searchForm.startEndOn"
                />
              </v-col>
              <v-col cols="12" md="3">
                <DateRange label="失效日期(迄)" v-model="searchForm.endEndOn" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  label="推薦碼"
                  v-model="searchForm.promoCode"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="9" align="right">
                <v-btn class="ma-2" :loading="loading" @click="handleSerach"
                  >查詢</v-btn
                >
                <v-btn class="ma-2" @click="handleClear">清除</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row style="margin-top: 5px">
      <v-col cols="12" md="10"></v-col>
      <v-col cols="12" md="2" style="text-align: right">
        <v-icon @click="handleCreate">mdi-plus</v-icon>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="codes"
      :items-per-page="page.perPage"
      :server-items-length="totalCount"
      :header-props="{ sortIcon: null }"
      @update:options="update"
    >
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.promoCode }}</td>
          <td>{{ row.item.promotionFor === 1 ? '換入' : '換出' }}</td>
          <td>{{ row.item.description }}</td>
          <td>
            商品分類: {{ row.item.categories.join() }} <br />
            標籤: {{ row.item.tags.join() }}
          </td>
          <td>{{ row.item.startOn | date }}</td>
          <td>{{ row.item.endOn | date }}</td>
          <td>
            <v-switch
              v-model="row.item.isEnabled"
              @click.stop="handleModifyStatus(row.item)"
            ></v-switch>
          </td>
          <td>
            <button @click="handleEdit(row.item.promoCode)">
              <v-icon>mdi-lead-pencil</v-icon>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- <Dialog :title="'確定要刪除此新聞嗎 ?'" :isVisible="isDeleteDialogVisible" @ok="handleDelete" @cancel="handleCloseDialog"/> -->
  </div>
</template>

<script>
// import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import DateRange from '@/components/DateRange.vue';

const defaultPage = {
  pageSize: 10,
  pageNo: 1,
};

export default {
  components: {
    DateRange,
  },
  data() {
    return {
      panel: 0,
      loading: false,
      searchForm: {
        startStartOn: '',
        endStartOn: '',
        startEndOn: '',
        endEndOn: '',
        promoCode: '',
      },
      codes: [],
      totalCount: 0,
      page: {
        ...defaultPage,
      },
      headers: [
        { text: '推薦碼', value: 'promoCode' },
        { text: '使用情境', value: 'promotionFor' },
        { text: '折扣方式', value: 'description' },
        { text: '適用範圍', value: 'scope' },
        { text: '生效日期', value: 'startDate' },
        { text: '失效日期', value: 'endDate' },
        { text: '狀態', value: 'isEnable' },
        { text: '修改', value: 'edit' },
      ],
    };
  },
  methods: {
    update(options) {
      this.page = {
        pageSize: options.itemsPerPage,
        pageNo: options.page,
      };
      this.getPromoCodeList();
    },
    async getPromoCodeList() {
      const params = {
        ...this.removeEmptyValue(this.page),
        ...this.removeEmptyValue(this.searchForm),
        pageSize:
          this.page.pageSize === -1 ? this.totalCount : this.page.pageSize,
      };
      const {
        data: { data, totalCount },
      } = await api.promotion.list(params);
      this.totalCount = totalCount;
      this.codes = data || [];
    },
    handleSerach() {
      this.loading = true;
      this.page.pageNo = 1;
      this.getPromoCodeList();
      this.loading = false;
    },
    removeEmptyValue(object) {
      const newObj = {};
      Object.keys(object).forEach((key) => {
        if (!(object[key] === '' || object[key] === undefined || object[key] === null)) {
          newObj[key] = object[key];
        }
      });
      return newObj;
    },
    handleClear() {
      this.searchForm = {
        startStartOn: '',
        endStartOn: '',
        startEndOn: '',
        endEndOn: '',
        promoCode: '',
      };
      this.page.pageNo = 1;
      this.getPromoCodeList();
    },
    async handleModifyStatus(code) {
      const { status } = await api.promotion.modifyStatus(
        code.promoCode,
        code.isEnabled,
      );
      if (status === 1) {
        this.getPromoCodeList();
      }
    },
    handleEdit(promoCode) {
      this.$router.push({
        name: 'promotion-code-edit',
        params: { pcode: promoCode },
      });
    },
    handleCreate() {
      this.$router.push({ name: 'promotion-code-create' });
    },
  },
};
</script>
